export const DOCUMENTS_DEMO_ITEMS = [
  {
    id: 'doc-1',
    name: 'Nexus Procurement — UI Spec.docx',
    category: 'docs',
    updatedAt: 'Jun 12, 2026',
    sizeLabel: '248 KB',
  },
  {
    id: 'doc-2',
    name: 'Vendor Onboarding Checklist.docx',
    category: 'docs',
    updatedAt: 'Jun 10, 2026',
    sizeLabel: '96 KB',
  },
  {
    id: 'doc-3',
    name: 'Spend Forecast Q3.xlsx',
    category: 'xls',
    updatedAt: 'Jun 8, 2026',
    sizeLabel: '1.2 MB',
  },
  {
    id: 'doc-4',
    name: 'RFQ Line Items — Laptops.xlsx',
    category: 'xls',
    updatedAt: 'Jun 5, 2026',
    sizeLabel: '412 KB',
  },
  {
    id: 'doc-5',
    name: 'Dashboard Wireframe.png',
    category: 'images',
    updatedAt: 'Jun 4, 2026',
    sizeLabel: '3.8 MB',
  },
  {
    id: 'doc-6',
    name: 'Catalog Grid — Tablet.png',
    category: 'images',
    updatedAt: 'Jun 3, 2026',
    sizeLabel: '2.1 MB',
  },
  {
    id: 'doc-7',
    name: 'Procurement Policy Handbook.pdf',
    category: 'document',
    updatedAt: 'May 28, 2026',
    sizeLabel: '4.6 MB',
  },
  {
    id: 'doc-8',
    name: 'Integration Test Report.pdf',
    category: 'document',
    updatedAt: 'May 22, 2026',
    sizeLabel: '890 KB',
  },
]

/**
 * @param {DocumentItem['category']} category
 */
